import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const PERIODS_DOC = 'periods';

const converter = {
  toFirestore(
    program: BonusTypes.BonusPeriod,
  ): firebase.firestore.DocumentData {
    return program;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusTypes.BonusPeriod>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusTypes.BonusPeriod {
    const data = {
      ...snapshot.data(options),
    };

    return data;
  },
};

const getBonusPeriodsRef = ({
  accountId,
  db,
  programDoc,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
  programDoc: string;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_COLLECTION)
    .doc(programDoc)
    .collection(PERIODS_DOC)
    .withConverter(converter);
};

export default getBonusPeriodsRef;
